/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ats_Score_Optimize_HintInputs */

const en_ats_score_optimize_hint = /** @type {(inputs: Ats_Score_Optimize_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boost your score with AI keyword suggestions from a job description.`)
};

const de_ats_score_optimize_hint = /** @type {(inputs: Ats_Score_Optimize_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbessere deinen Score mit KI-Keyword-Vorschlägen aus einer Stellenbeschreibung.`)
};

const fr_ats_score_optimize_hint = /** @type {(inputs: Ats_Score_Optimize_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Améliorez votre score avec des suggestions de mots-clés IA à partir d'une description de poste.`)
};

const es_ats_score_optimize_hint = /** @type {(inputs: Ats_Score_Optimize_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejora tu puntuación con sugerencias de palabras clave con IA a partir de una descripción del puesto.`)
};

const it_ats_score_optimize_hint = /** @type {(inputs: Ats_Score_Optimize_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Migliora il tuo punteggio con suggerimenti di parole chiave IA da una descrizione del lavoro.`)
};

const nl_ats_score_optimize_hint = /** @type {(inputs: Ats_Score_Optimize_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verhoog je score met AI-trefwoordsuggesties uit een functieomschrijving.`)
};

const pl_ats_score_optimize_hint = /** @type {(inputs: Ats_Score_Optimize_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zwiększ swój wynik dzięki AI sugerującym słowa kluczowe z opisu stanowiska.`)
};

const fi_ats_score_optimize_hint = /** @type {(inputs: Ats_Score_Optimize_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paranna pisteitäsi AI-avainsanaehdotuksilla työpaikkailmoituksesta.`)
};

const da_ats_score_optimize_hint = /** @type {(inputs: Ats_Score_Optimize_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forbedr din score med AI-søgeordsforslag fra en jobbeskrivelse.`)
};

const sv_ats_score_optimize_hint = /** @type {(inputs: Ats_Score_Optimize_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öka din poäng med AI-nyckelordsförslag från en jobbannons.`)
};

/**
* | output |
* | --- |
* | "Boost your score with AI keyword suggestions from a job description." |
*
* @param {Ats_Score_Optimize_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const ats_score_optimize_hint = /** @type {((inputs?: Ats_Score_Optimize_HintInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ats_Score_Optimize_HintInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ats_score_optimize_hint(inputs)
	if (locale === "fr") return fr_ats_score_optimize_hint(inputs)
	if (locale === "es") return es_ats_score_optimize_hint(inputs)
	if (locale === "it") return it_ats_score_optimize_hint(inputs)
	if (locale === "nl") return nl_ats_score_optimize_hint(inputs)
	if (locale === "pl") return pl_ats_score_optimize_hint(inputs)
	if (locale === "fi") return fi_ats_score_optimize_hint(inputs)
	if (locale === "da") return da_ats_score_optimize_hint(inputs)
	if (locale === "sv") return sv_ats_score_optimize_hint(inputs)
	return en_ats_score_optimize_hint(inputs)
});